<template>
  <div class="room-setting roomGroup" data-grm-comp="GroupSetting">
    <div class="room-setting-header direction-column">
      <div class="title-wrapper">
        <p class="title large">{{ $t("group.setting.title") }}</p>
        <div class="button-box">
            <div class="room-group-setting-button-wrapper">
                <button class="room-group-setting-button" @click="onChangeRoomGroupDiscussion">{{ $t("group.setting.change") }}</button>
                <button class="room-group-setting-button end" @click="onEndRoomGroupDiscussion">{{ $t("group.setting.quit") }}</button>
            </div>
            <GrmCloseBtn color="white" @click="onCloseRoomSetting" />
        </div>
      </div>
    </div>
    <div class="room-setting-body roomGroup">
      <perfect-scrollbar>
        <div class="room-setting-list-scroll">
          <ul class="room-setting-list">
            <li class="room-setting-item roomGroup">
              <GrmSelect :label="$t('group.setting.amount')"
                v-model="roomGroupCount"
                :options="[
                  { value: 2, title: $t('group.setting.groupCount', { '0' : '2' }) , selected: roomGroupCount === 2},
                  { value: 3, title: $t('group.setting.groupCount', { '0' : '3' }) , selected: roomGroupCount === 3},
                  { value: 4, title: $t('group.setting.groupCount', { '0' : '4' }) , selected: roomGroupCount === 4},
                  { value: 5, title: $t('group.setting.groupCount', { '0' : '5' }) , selected: roomGroupCount === 5},
                  { value: 6, title: $t('group.setting.groupCount', { '0' : '6' }) , selected: roomGroupCount === 6},
                  { value: 7, title: $t('group.setting.groupCount', { '0' : '7' }) , selected: roomGroupCount === 7},
                  { value: 8, title: $t('group.setting.groupCount', { '0' : '8' }) , selected: roomGroupCount === 8},
                  { value: 9, title: $t('group.setting.groupCount', { '0' : '9' }) , selected: roomGroupCount === 9},
                  { value: 10, title: $t('group.setting.groupCount', { '0' : '10' }) , selected: roomGroupCount === 10},
                ]"
              />
            </li>
            <li class="room-setting-item roomGroup">
              <GrmSwitch id="showRoomGroupUserInFilmArea" :label="$t('group.setting.duplicate')" :value.sync="showRoomGroupUserInFilmArea" />
            </li>
            <li class="room-setting-item roomGroup" v-if="!isRoomMode('group')">
              <GrmSwitch id="showRoomGroupUserAutoDivide" :label="$t('group.setting.randomSplit')" :value.sync="showRoomGroupUserAutoDivide" />
            </li>
          </ul>
          <div class="room-group-setting-button-wrapper pc">
            <button class="room-group-setting-button" @click="onChangeRoomGroupDiscussion">{{ $t("group.setting.change") }}</button>
            <button class="room-group-setting-button end" style="margin-top: 10px;" @click="onEndRoomGroupDiscussion">{{ $t("group.setting.quit") }}</button>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="room-setting-footer"></div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";

import GrmSwitch from '@/components/Common/switch/GrmSwitch'
import GrmSelect from '@/components/Common/select/GrmSelect.vue'
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn";

export default {
  name: 'GroupSettingModal',
  components: {
    GrmSwitch,
    GrmSelect,
    GrmCloseBtn,
  },
  data() {
    return {
      isShow: false,
      roomGroupCount: 2,
      showRoomGroupUserInFilmArea: true,
      showRoomGroupUserAutoDivide: false,
      createRoomGroupId: 'group-'
    }
  },
  computed: {
    ...mapGetters('room', [
        'isRoomMode'
    ]),
    ...mapGetters('user', [
      'isParticipantRole',
      'hasEmceeRole',
      'roomUserList'
    ]),
    ...mapGetters('roomGroup', [
      'roomGroupListNoDefaultActive',
    ]),
    ...mapGetters('call', [
      'roomCall',
    ])
  },
  created() {
    this.roomGroupCount = this.isRoomMode('group') ? this.roomGroupListNoDefaultActive.length : 2;
    this.showRoomGroupUserInFilmArea = !this.roomCall.hideRoomGroupUserInFilmArea
  },
  methods: {
    ...mapActions('roomGroup',[
        'endRoomGroup',
        'addRoomGroup',
        'removeRoomGroup',
        'changeHideRoomGroupUserInFilmArea'
    ]),
    async onChangeRoomGroupDiscussion() {
      if(!this.showRoomGroupUserInFilmArea != this.roomCall.hideRoomGroupUserInFilmArea) {
        this.changeHideRoomGroupUserInFilmArea(!this.showRoomGroupUserInFilmArea)
      }

      if(this.roomGroupCount < 2) return;

      let currentRoomGroupList = this.roomGroupListNoDefaultActive;
      let diffCount = currentRoomGroupList.length - this.roomGroupCount
      if(diffCount > 0) { // 그룹 제거
        let roomGroupList = currentRoomGroupList.slice(this.roomGroupCount)
        this.removeRoomGroup(roomGroupList);

      } else if (diffCount < 0) { // 그룹 추가
        let roomGroupList = this.createRoomGroupListByIndex(currentRoomGroupList.length + 1, this.roomGroupCount)
        this.addRoomGroup(roomGroupList)
      }
      this.$modal('GroupSettingModal')
    },
    onEndRoomGroupDiscussion() {
      this.$alert({
        text: this.$t('group.setting.quitText'),
        ok: () => {
          this.endRoomGroup({roomMode: 'call'});
          this.onCloseRoomSetting();
        },
      })
    },
    createRoomGroupList() {
      let roomGroupCount = this.roomGroupCount < 2 ? 2 : this.roomGroupCount
      let roomGroupList = this.createRoomGroupListByIndex(1, roomGroupCount)

      if(!this.showRoomGroupUserAutoDivide) {
        return roomGroupList;
      }
      let randomUserList = _.shuffle(_.cloneDeep(this.roomUserList).filter(ru => !this.hasEmceeRole(ru)).map(ru => ru.userId))

      let roomGroupListLength = roomGroupList.length - 1
      let roomGroupListIndex = 0
      for(let i = 0 ; i <randomUserList.length; i++ ){
        roomGroupList[roomGroupListIndex].userIdList.push(randomUserList[i])
        roomGroupListIndex = roomGroupListIndex >= roomGroupListLength ? 0 : roomGroupListIndex + 1
      }

      return roomGroupList;
    },
    createRoomGroupListByIndex(startIndex, endIndex) {
      let roomGroupList = []
      for(let i = startIndex; i <= endIndex; i++ ) {
        roomGroupList.push({
          roomGroupId: this.createRoomGroupId + i,
          roomGroupIndex: i,
          groupName: this.$t('group.setting.group') + i,
          userIdList: []
        })
      }
      return roomGroupList
    },
    onCloseRoomSetting() {
      this.$modal('GroupSettingModal')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/roomType/conf/css/_roomSetting';

.room-setting {
  &.roomGroup {
    top: 60px;
    left: 80px;
    width: 300px;
    height: max-content;
    border-radius: 10px;
    padding: 16px;
    z-index: 1;
  }
}
.room-setting-body{
  min-height: fit-content;
}
.title-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .button-box{
    display: none;
  }
}
.room-group-setting-button-wrapper {
  margin-top: 10px;
}
.room-group-setting-button {
  width: 100%;
  padding: 0 16px;
  border-radius: 4px;
  background-color: $mainColor;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  line-height: 43px;
  transition: 0.1s ease-out;
  &.end {
    background-color: #d05;
    &:hover {
      background-color: #f05;
    }
  }
  &:hover {
    background-color: #39f;
  }
}
[grm-device-mobile] {
  [data-open-extend-menu] {
    ~ .room-setting {
      &.roomGroup {
        left: 80px;
      }
    }
  }

  .room-setting{
    &.roomGroup{
      width: auto;
      top: 60px;
      right: 20px;
      left: 20px;
    }
  }
  @media (max-height: 610px) and (orientation: landscape){
    .title-wrapper{
      .button-box{
        display: flex;
        .room-group-setting-button-wrapper{
          display: flex;
          margin-top: 0;
          margin-right: 10px;
          gap: 10px;

          .room-group-setting-button{
            width: 100px;
            line-height: 20px;
            padding: 5px 0;
          }
        }
      }
    }
    .room-group-setting-button-wrapper{
      &.pc{
        display: none;
      }
    }
  }
}
</style>
